














































































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {RegisterEnum} from '@/store/auth/auth.enum';
import {
  Member,
  MemberService, MemberServiceFreeTime
} from '@/store/member/member.types';
import {Service, ServiceInitState} from '@/store/service/service.types';
import {MemberServiceType} from '@/store/member/member.enum';
import SelSubServiceComponent from '@/components/register/SelSubService.vue';
import BgThemePublic from '@/components/bg-theme-public.vue';
import {Toast} from '@/store/toast/toast.types';


@Component({
  components: {
    SelSubServiceComponent,
    BgThemePublic
  }
})
export default class SteppersSixComponent extends Vue {

  @State('service') serviceState!: ServiceInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_getServiceForRegister', {namespace: 'service'}) getServiceForRegister!: () => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;

  public serviceList = [{id: ''}] as Service[];
  public MemberData = {} as Member;

  async mounted() {
    if (JSON.parse(localStorage.getItem(RegisterEnum.Register) as string) as Member === null) {
      await this.$router.push('/register');
      return;
    }
    this.MemberData = JSON.parse(localStorage.getItem(RegisterEnum.Register) as string) as Member;
    await this.getServiceForRegister();
    this.serviceList = this.serviceState.service;
    this.Loading(false);
  }

  async ChangeData() {
    setTimeout(() => {
      localStorage.setItem(RegisterEnum.Register, JSON.stringify(this.MemberData).toString());
    }, 100);
  }

  addService() {
    let newRow = {
      subServiceId: '',
      serviceId: '',
      crossBranch: false,
      memberServiceType: MemberServiceType.ServiceReceiver,
      memberServiceFreeTimes: [
        {freeDay: '1', use: false},
        {freeDay: '2', use: false},
        {freeDay: '3', use: false},
        {freeDay: '4', use: false},
        {freeDay: '5', use: false},
        {freeDay: '6', use: false},
        {freeDay: '7', use: false},
      ] as MemberServiceFreeTime[]
    } as MemberService;
    this.MemberData.memberServices.push(newRow)
  }

  delService(row: number) {
    this.MemberData.memberServices.splice(row,1);
    localStorage.setItem(RegisterEnum.Register, JSON.stringify(this.MemberData).toString());
  }

  showName(day: string) {
    switch (day) {
      case '1': {
        return 'วันอาทิตย์';
      }
      case '2': {
        return 'วันจันทร์';
      }
      case '3': {
        return 'วันอังคาร';
      }
      case '4': {
        return 'วันพุธ';
      }
      case '5': {
        return 'วันพฤหัสบดี';
      }
      case '6': {
        return 'วันศุกร์';
      }
      case '7': {
        return 'วันเสาร์';
      }
      default: {
        return '';
      }
    }
  }

  actionSetValueSub(e: { index: number, subServiceId: string }) {
    this.MemberData.memberServices[e.index].subServiceId = e.subServiceId;
    setTimeout(() => {
      localStorage.setItem(RegisterEnum.Register, JSON.stringify(this.MemberData).toString());
    }, 100);
  }

  async selService(e: { target: { value: string } }) {
    if (e.target.value) {
      setTimeout(() => {
        localStorage.setItem(RegisterEnum.Register, JSON.stringify(this.MemberData).toString());
      }, 100);
    }
  }

  async stepSix() {
    let service = this.MemberData.memberServices.filter((x) => x.memberServiceType === MemberServiceType.ServiceReceiver);

    if (service.length === 0) {
      this.Toast({
        heading: '!',
        message: 'เลือกบริการ',
        type: 'danger'
      }).then();
      return false;
    }

    let checkService = service.map((x) => {
      return x.memberServiceFreeTimes.filter((y) => y.use)
    })

    for (const num of checkService) {
      if(num.length === 0) {
        this.Toast({
          heading: '!',
          message: 'เลือกวันที่',
          type: 'danger'
        }).then();
        return false;
      }
    }

    await this.$router.push('/register-4');

  }

  async everyDay(e: boolean, index:number) {
    if(e) {
      this.MemberData.memberServices[index].memberServiceFreeTimes.forEach((x) => x.use = true);
    }else {
      this.MemberData.memberServices[index].memberServiceFreeTimes.forEach((x) => x.use = false);
    }
    await this.ChangeData();
  }

}
